import { useEffect, useState } from 'react'
import { reaction, when } from 'mobx'
import { pick } from 'lodash'

export const useConversationListener = (store, actions) => {
  const [reactionDisposer, setReactionDisposer] = useState(null)

  const timeFields = ['messageReceivedAt', 'notificationReceivedAt', 'createdAt']
  //TODO: CHECK WITH KEVIN
  const listen = () => when(() => !!store.conversations, () => {
    setReactionDisposer(
      reaction(
        () => store.conversations.map(c => pick(c, ['conversationUid', ...timeFields])),
        conv => {
          const now = Math.floor(Date.now() / 1000) - 100
          //finds the conversation with recent Message/Notification
          const changed = conv.find(c => timeFields.some(name => c[ name ] >= now))

          if (!changed) {
            console.warn('No conversation found. Increase treshold!')
            return
          }
          if (!store.widgetState.isOpen) {
            actions.chat.setUserConversation(changed.conversationUid)
          } else if (changed.conversationUid === store.conversationUid) {
            //delays read execution so notification could be seen for a second
            setTimeout(() => actions.chat.readConversation(store.conversation), 1000)
          }
        }
      )
    )
  })

  useEffect(() => {
    listen()
    return () => reactionDisposer()
  }, [])
}
